import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import UserSettings from "../../components/UserSettings/UserSettings";

const UserPage = () => {


    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar/>
                    <UserSettings/>
                </div>
            </div>
        </div>
    );
};

export default UserPage;
